import React from 'react';

import { Container, Row, Col } from 'react-bootstrap';

const Route29Banner = ({language}) => {
    return (
        <section className="route29-banner">
            <div className="route29-header mx-2 mb-5">
                <h1>{language === "Chinese" ? "28K經典路線" : "28K ROUTE"} <span className='theme-color'><em> The Ride</em></span></h1>
            </div>
            <Container>
                <Row className='align-items-center'>
                    <Col md={6} className='px-3'>
                        <h3 className='font-italic mx-4 my-3'><em>{language === "Chinese" ? "組別資訊" : "CATEGORY INFO"}</em></h3>
                        <ul>
                            <li>{language === "Chinese" ? "報名費：NT$3,500元" : "Entry Fee: NT$3,500"}</li>
                            <li className='text-danger'>{language === "Chinese" ? "競賽資訊：本組別不設登山王路段，依大會計時取男女前三名上台頒發獎座；28K電輔車組報名費相同，不列入競賽排名。" : "Competition: There are no KOM segments in this category. The top 3 men and top 3 women by official time receive trophies on stage. The 28K E-bike category has the same entry fee but is not ranked."}</li>
                            <li>{language === "Chinese" ? "報名資格：身心健康且具有良好、純熟單車騎乘技術及經驗，體能適應強度可以在4小時內完騎，並無條件願意踏實遵守道路交通規則與大會交通維運工作人員引導、安全騎乘者，即符合資格。" : "Eligibility: Open to riders in good physical and mental health with solid, experienced bike-handling skills and the fitness to finish within 4 hours. Riders must agree to strictly obey traffic regulations, follow the instructions of event traffic control staff, and ride safely."}</li>
                            <p className='danger'>{language === "Chinese" ? "※28K經典組（含電輔車組）不限年齡，未滿16歲參加者須附監護人同意書。" : "*28K The Ride (including the E-bike category) has no age limit. Riders under 16 must submit a parental/guardian consent form."}</p>
                            <li>{language === "Chinese" ? "計時方式：晶片計時" : "Timing: Chip timing"}</li>
                        </ul>
                    </Col>
                    <Col md={6} className='justify-content-center px-5'>
                        <table>
                            <thead>
                                <tr>
                                    <th>{language === "Chinese" ? "重要時程表" : "Key Times"}</th>
                                    <th>{language === "Chinese" ? "時間" : "Time"}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{language === "Chinese" ? "集合時間" : "Assembly Time"}</td>
                                    <td>05:00-05:30</td>
                                </tr>
                                <tr>
                                    <td>{language === "Chinese" ? "鳴槍時間" : "Start Time"}</td>
                                    <td>{language === "Chinese" ? "06:30-06:40（分批出發，電輔車組最後一批）" : "06:30-06:40 (wave starts; E-bikes in the final wave)"}</td>
                                </tr>
                                <tr>
                                    <td>{language === "Chinese" ? "時間限制" : "Time Limit"}</td>
                                    <td>{language === "Chinese" ? "4小時（依出發梯次，10:30-10:50關門）" : "4 hours (finish closes 10:30-10:50, depending on start wave)"}</td>
                                </tr>
                                {/* <tr>
                                    <td>{language === "Chinese" ? "衣物保管時間" : "Bag Drop"}</td>
                                    <td>05：00-13：30</td>
                                </tr> */}
                            </tbody>
                        </table>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default Route29Banner